import { Navigate, type RouteObject } from 'react-router';
import { OverviewPage } from './OverviewPage';
import { PartnersPage } from './PartnersPage';
import { PartnerDetailPage } from './PartnerDetailPage';
import { StatementsPage } from './StatementsPage';
import { StatementDetailPage } from './StatementDetailPage';
import { useStlPerms } from './api';

function SettlementEntry() {
  const p = useStlPerms();
  const target = p.customer ? '/settlements/customers' : p.supplier ? '/settlements/suppliers' : p.statement ? '/settlements/statements' : '/settlements/overview';
  return <Navigate to={target} replace />;
}

/** 往来结算（只读）。path 相对 /v2，由主会话接进 router.tsx 的 AppShell children */
export const routes: RouteObject[] = [
  { path: 'settlements', element: <SettlementEntry /> },
  { path: 'settlements/overview', element: <OverviewPage /> },
  { path: 'settlements/customers', element: <PartnersPage key="customer" scope="customer" /> },
  { path: 'settlements/customers/:partnerId', element: <PartnerDetailPage key="customer" scope="customer" /> },
  { path: 'settlements/suppliers', element: <PartnersPage key="supplier" scope="supplier" /> },
  { path: 'settlements/suppliers/:partnerId', element: <PartnerDetailPage key="supplier" scope="supplier" /> },
  { path: 'settlements/statements', element: <StatementsPage /> },
  { path: 'settlements/statements/:id', element: <StatementDetailPage /> },
];
